"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _AccessoryItemComponent = _interopRequireDefault(require("./AccessoryItemComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RelatedAccessoriesComponent = function RelatedAccessoriesComponent(_ref) {
  var currentTab = _ref.currentTab,
      tabName = _ref.tabName;
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var relatedAccessories = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.relatedAccessories;
  });
  var accessoriesTab = {
    dots: true,
    infinite: true,
    centerMode: false,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    arrows: false,
    slidesToScroll: 1
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, relatedAccessories && /*#__PURE__*/_react["default"].createElement("div", {
    className: currentTab === tabName ? "tab__content__section active" : "tab__content__section",
    "data-content": tabName
  }, isMobile && relatedAccessories && /*#__PURE__*/_react["default"].createElement("div", {
    className: "accessories-slider"
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], accessoriesTab, relatedAccessories.map(function (accessory, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_AccessoryItemComponent["default"], {
      accessory: accessory,
      index: index
    }));
  }))), !isMobile && relatedAccessories.map(function (accessory, index) {
    return /*#__PURE__*/_react["default"].createElement(_AccessoryItemComponent["default"], {
      accessory: accessory,
      index: index,
      key: index
    });
  })));
};

var _default = RelatedAccessoriesComponent;
exports["default"] = _default;